import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";

type StockClosingActionsProps = {
  loading: boolean;
  needsClosing: boolean;
  fetching: boolean;
  missingDays: number;
  missingStockVariantsCount?: number;
  onRunClosing: () => void;
  onRefresh: () => void;
  disabled?: boolean;
};

export function StockClosingActions({
  loading,
  needsClosing,
  fetching,
  missingDays,
  missingStockVariantsCount = 0,
  onRunClosing,
  onRefresh,
  disabled = false,
}: StockClosingActionsProps) {
  const getButtonText = () => {
    if (loading) return "Running…";
    const parts: string[] = [];
    if (missingDays > 0) parts.push(`${missingDays}d`);
    if (missingStockVariantsCount > 0)
      parts.push(`${missingStockVariantsCount} variants`);
    return `Run Closing${parts.length > 0 ? ` (${parts.join(", ")})` : ""}`;
  };

  return (
    <div className="flex items-center gap-2 shrink-0 w-full md:w-auto">
      <Button
        onClick={onRunClosing}
        size="sm"
        disabled={!needsClosing || loading || fetching || disabled}
        title={disabled ? "Hook up onRunClosing to enable" : undefined}
        className="flex-1 md:flex-initial"
      >
        {loading ? <Loader2 className="h-3.5 w-3.5 sm:h-4 sm:w-4 animate-spin" /> : null}
        <span className="truncate">{getButtonText()}</span>
      </Button>
      <Button
        onClick={onRefresh}
        disabled={fetching}
        variant="outline"
        size="sm"
        className="shrink-0"
      >
        Refresh
      </Button>
    </div>
  );
}
